import { IBasicUser } from '@sdk/contracts';
import { Avatar, Tooltip } from 'antd';
import { useTheme } from 'styled-components';

import { UserName, Wrapper } from './UserAvatar.styles';

const AVATAR_SIZE = 32;
interface Props {
  user?: IBasicUser;
  displayFullName?: boolean;
}

export const UserAvatar: React.FC<Props> = ({ user, displayFullName = false }) => {
  const { colors } = useTheme();
  const fullName = user ? `${user.name} ${user.lastName}` : 'Manager Ucademy';

  return (
    <Wrapper>
      <Tooltip title={fullName}>
        <Avatar
          style={{ backgroundColor: !user ? colors.purple4 : undefined }}
          size={AVATAR_SIZE}
          src={user?.avatar?.url}>
          {user?.name?.[0] ?? 'U'}
        </Avatar>
      </Tooltip>
      {displayFullName && <UserName>{fullName}</UserName>}
    </Wrapper>
  );
};
